<div class="table-filters-container">
  <div class="chip-filters">
    <mat-chip-set #filterChips>
      <div class="chip-set-container">
        <!--
        editFilterPopover needs to be accessed from template
        or else the popover position is incorrect
        -->
        @for (filter of filtersChips(); track filter; let index = $index) {
          <mat-chip
            (removed)="removeFilter(filter)"
            (click)="openEditFilter(index, filter); editFilterPopover.open()"
            [glxyPopover]="editFilterPopover"
            [attr.data-testid]="'chip-value-' + filter.fieldId"
            [removable]="!filter?.definition?.preset"
            >
            <span class="chip-wrapper">
              {{ filter.definition?.fieldName }}
              @if (
                filter.operatorSymbol &&
                (filter.selectedValue || filter.canHaveEmptyValue || filter.customChip !== null)
                ) {
                <span
                  class="chip-symbol"
                  >
                  {{ filter.operatorSymbol }}
                </span>
              }
              @if (filter.customChip) {
                <span>
                  <glxy-custom-filter-chip [filterChip]="filter.customChip" [initialValue]="filter.values || []" />
                </span>
              } @else {
                @if (filter.selectedValue) {
                  <span>
                    {{ filter.selectedValue }}
                  </span>
                }
              }
            </span>
            @if ((filter.selectedValue || filter.canHaveEmptyValue) && !filter.definition?.lockedValue) {
              <button
                (click)="clearFilterValue(filter)"
                matChipRemove
                >
                <mat-icon>cancel</mat-icon>
              </button>
            }

            <glxy-popover
              #editFilterPopover
              [closeOnBackdropClick]="true"
              [closeOnEscapeKey]="true"
              [positions]="popoverPositions"
              [keepOnScreen]="true"
              [maxWidth]="'100%'"
              [maxHeight]="'100%'"
              [padding]="'none'"
              (backdropClick)="closePopovers()"
              >
              @let selected = selectedFilterToEdit();
              @if (selected && selected.filter.filterId === filter.filterId) {
                <glxy-edit-filter-modal
                  #editFilterModal
                  [selectedFilter]="selected.filter"
                  (applyFilterChanges)="updateSelectedFilter($event)"
                  />
              }
            </glxy-popover>
          </mat-chip>
        }
      </div>
    </mat-chip-set>
  </div>

  @if (showAddFilter) {
    <div class="filter-button-group">
      <button
        class="add-filter-button"
        (click)="openAddFilter()"
        [glxyPopover]="addFilterPopover"
        data-testid="add-filter-button"
        >
        <mat-icon>add</mat-icon>
        {{ 'GALAXY.FILTER.CHIP.ADD_FILTER' | translate }}
        <glxy-popover
          #addFilterPopover
          data-testid="add-filter-modal"
          [closeOnBackdropClick]="true"
          [closeOnEscapeKey]="true"
          [positions]="popoverPositions"
          [keepOnScreen]="true"
          [maxWidth]="'100%'"
          [maxHeight]="'100%'"
          [padding]="'none'"
          (backdropClick)="closePopovers()"
          >
          @if (showEditFilter()) {
            <glxy-edit-filter-modal #addEditFilterModal (applyFilterChanges)="addSelectedFilter($event)" />
          }
        </glxy-popover>
      </button>
      @if (canClear()) {
        <button class="clear-filters-button" (click)="clearFilters()">
          <mat-icon>clear</mat-icon>
          {{ 'GALAXY.FILTER.CHIP.CLEAR_FILTERS' | translate }}
        </button>
      }
    </div>
  }
</div>
